import type { RouteType } from 'xui-pro';

import type { IRoute } from '@/types/router';
import RepairInfoSearch from '@/pages/RepairInfoSearch';
import RepairInfoSearchDetail from '@/pages/RepairInfoSearch/detail';
import NoticeDetail from '@/pages/NoticeDetail';
import NotFound from '@/pages/NotFound';

export const routes: RouteType[] = [
  {
    // 维修资料查询首页
    path: '/afs-sip/repair-info-search',
    exact: true,
    component: RepairInfoSearch
  },
  {
    // 维修资料查询车型详情页
    path: '/afs-sip/repair-info-search/car-model/:modelCode',
    exact: false,
    component: RepairInfoSearchDetail
  },
  {
    // 维修资料查询VIN详情页
    path: '/afs-sip/repair-info-search/vin/:vin/:modelCode',
    exact: false,
    component: RepairInfoSearchDetail
  },
  {
    // 通知详情页
    path: '/afs-sip/repair-info-search/notice/:noticeId',
    exact: false,
    component: NoticeDetail
  },
  {
    // 404
    path: '/404',
    exact: false,
    component: NotFound
  }
];

export const menusData: IRoute[] = [
  {
    url: '/afs-sip/repair-info-search/car-model/:modelCode',
    menuName: '车型详情'
  },
  {
    url: '/afs-sip/repair-info-search/vin/:vin/:modelCode',
    menuName: 'VIN详情'
  },
  {
    url: '/afs-sip/repair-info-search/notice/:noticeId',
    menuName: '通知详情'
  }
];
